import type { App } from "../app.ts";
import { useAppState } from "./hooks.ts";
import { IconButton } from "./icon.tsx";

/** How the note is written: Live Markdown, Rich text, or the raw Markdown. */
export function Modes({ app }: { app: App }) {
  const s = useAppState(app);
  return (
    <div class="island top modes" role="toolbar" aria-label="Writing mode">
      <IconButton
        icon="live"
        label="Live Markdown"
        on={s.editorId === "lexical-live"}
        aria-pressed={s.editorId === "lexical-live"}
        onClick={() => app.setEditorId("lexical-live")}
      />
      <IconButton
        icon="rich"
        label="Rich text"
        on={s.editorId === "rich"}
        aria-pressed={s.editorId === "rich"}
        onClick={() => app.setEditorId("rich")}
      />
      <IconButton
        icon="plain"
        label="Plain text"
        tip="Plain text, raw Markdown"
        on={s.editorId === "plain"}
        aria-pressed={s.editorId === "plain"}
        onClick={() => app.toggleRaw()}
      />
    </div>
  );
}
